module.exports = __webpack_public_path__ + "img/form1.bcce17f9.jpg";